import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=169e30d5&scoped=true&"
import script from "./CreateEvent.vue?vue&type=script&lang=ts&"
export * from "./CreateEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=169e30d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169e30d5",
  null
  
)

export default component.exports